module.exports = __webpack_public_path__ + "img/buscar.05380154.svg";